/**
 * Computes the active step indices for a guided intake flow.
 *
 * Booking and Payment steps are conditionally appended after the base
 * (review) step. Returns the total active step count and the patient's
 * current 1-indexed position so the progress bar and step tabs can render
 * sequential numbers regardless of which optional steps are shown.
 */
export interface GuidedIntakeStepFlow {
  activeStepIndices: number[];
  totalSteps: number;
  stepPosition: number;
}

export function useGuidedIntakeStepFlow({
  baseStepCount,
  bookingStep,
  paymentStep,
  showBooking,
  showPayment,
  currentStep,
}: {
  baseStepCount: number;
  bookingStep: number;
  paymentStep: number;
  showBooking: boolean;
  showPayment: boolean;
  currentStep: number;
}): GuidedIntakeStepFlow {
  const activeStepIndices: number[] = [];
  for (let i = 1; i <= baseStepCount; i += 1) activeStepIndices.push(i);
  if (showBooking) activeStepIndices.push(bookingStep);
  if (showPayment) activeStepIndices.push(paymentStep);

  return {
    activeStepIndices,
    totalSteps: activeStepIndices.length,
    stepPosition: Math.max(1, activeStepIndices.indexOf(currentStep) + 1),
  };
}
